import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContenedorRegLogComponent } from 'src/app/pages/user/componentes/custom/contenedor-reg-log/contenedor-reg-log.component';
import { WorkshoppingService } from 'src/app/service/index.service';

@Component({
  selector: 'app-navigator-button',
  templateUrl: './navigator-button.component.html',
  styleUrls: ['./navigator-button.component.scss']
})
export class NavigatorButtonComponent implements OnInit {
  cantidad$ = this.wsdl.cantidad$;

  constructor(
    private wsdl: WorkshoppingService,
    private modalService: NgbModal) { }

  ngOnInit() {
  }

  openModalLogin() {
    const modalRef = this.modalService.open(ContenedorRegLogComponent, {
      size: 'md',
      centered: true,
      keyboard: true       // permite cerrar con ESC
    });

    //modalRef.componentInstance.product = product;

    modalRef.result.then(
      result => {
        console.log('Modal cerrado con:', result);
      },
      reason => {
        console.log('Modal descartado con:', reason);
      }
    );
  }

  focusSearch() {
    const input = document.querySelector('.search-bar input') as HTMLInputElement;
    if (input) {
      input.focus();
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

}
